import React, { Fragment, useEffect, useState } from 'react';

import HeaderV2 from '../../components/headerV2/HeaderV2';
import FooterV2 from '../../components/footerV2/FooterV2';
import AboutHero from '../../components/aboutHero/AboutHero';
import ContactSection from '../../components/ContactSection';

import '../AboutUsPage/aboutV2.css';

import metadataJSON from "../../data/metadata.json";
import schemadataJSON from "../../data/schemadata.json";
import { Helmet } from 'react-helmet'; 

const ContactPage = ({ path }) => {

    // Setting metadata and schemadata 
    const [metadata, setMetadata] = useState({title: "JJFIndia | Our Initiative"});
    const [schemadata, setSchemadata] = useState({});
    
    // Getting the schemadata and setting the schema data. 
    useEffect(() => {
        let tempMetadata = metadataJSON[path];
        let tempSchemadata = schemadataJSON[path];

        if(tempMetadata){
        setMetadata(tempMetadata);
        }else {
        tempMetadata = {
            title: "JJFIndia | Volunteer Opportunity",
            description: "JJFIndia Volunteer opportunity page",
            keywords: "",
            robots: "index, follow",
            canonical: "https://jjfindia.com/gallery/tree-plantation",
            openGraph: {
                title: "JJFIndia | Volunteer Opportunity",
                description: "JJFIndia Volunteer opportunity page",
                url: "https://jjfindia.com/gallery/tree-plantation"
            },
            twitter: {
                card: "summary_large_image",
                title: "JJFIndia | Volunteer Opportunity",
                description: "JJFIndia Volunteer opportunity page"
            }
        }

        setMetadata(tempMetadata);
        }

        // setting schema data 
        if(tempSchemadata) {
            setSchemadata(tempSchemadata);
        }

    }, [path]);

    return (
        <>
            <Helmet>
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
                <link
                    href="https://fonts.googleapis.com/css2?family=Anton&family=Inter:wght@400;500;600;700;800&display=swap"
                    rel="stylesheet"
                />

                {/* Basic Meta Tags */}
                <title>{metadata.title}</title>
                <meta name="description" content={metadata.description} />
                <meta name="keywords" content={metadata.keywords} />
                <meta name="robots" content={metadata.robots} />

                {/* Canonical URL */}
                <link rel="canonical" href={metadata.canonical} />

                {/* Open Graph */}
                <meta property="og:title" content={metadata.openGraph?.title} />
                <meta property="og:description" content={metadata.openGraph?.description} />
                <meta property="og:url" content={metadata.canonical} />

                {/* Twitter Cards */}
                {/* <meta name="twitter:card" content={metadata.twitter?.card} /> */}
                <meta name="twitter:title" content={metadata.twitter?.title} />
                <meta name="twitter:description" content={metadata.twitter?.description} />
                
                {/* Setting up schema data */}
                <script  type="application/ld+json" >{JSON.stringify(schemadata, null, 2)}</script>
            </Helmet>
            <Fragment>
                <div className="jjfv2">
                    <HeaderV2 />
                    <AboutHero
                        eyebrow="Get in touch"
                        title="Contact Us"
                        crumbs={[{ label: 'Home', to: '/' }, { label: 'Contact Us' }]}
                    />
                </div>
                <main className="page_content">
                    <ContactSection />
                </main>
                <div className="jjfv2">
                    <FooterV2 />
                </div>
            </Fragment>
        </>
    )
};

export default ContactPage;